const PERCENT = 100;
const PERCENT_DECIMALS = 1;

export function getInHandQty(receivedQty: number, distributedQty: number): number {
  return receivedQty - distributedQty;
}

export function getDistributedPercent(distributedQty: number, challanQty: number): number {
  if (challanQty === 0) return 0;
  return (distributedQty / challanQty) * PERCENT;
}

export function formatDistributedPercent(distributedQty: number, challanQty: number): string {
  return `${getDistributedPercent(distributedQty, challanQty).toFixed(PERCENT_DECIMALS)}%`;
}
